import React, { FC, useState } from "react";
import { InputDateTime, InputNumber, InputSelect, InputText } from "../../../../components/input";

import { IInputArrayFormProps, IInputArrayDataStructureItem } from "../../../../components/input/arrayData";
import { CreateNotification } from "../../../../components/notifier";
import { convertToDate, getDay, getDDMMYYYFormat} from "../../../../helper/dateTimeHelper";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { ObjectUtils } from "../../../../modules/utils";
import { UploadFile } from "../../uploadFile";
import { InputSelectTag } from "../../../../components/input/select-tag";
import { Upload } from "../../upload";
import { InputDateRangePicker } from "../../../../components/input/date-range-picker";
import { InputGroupSelect } from "../../../../components/input/select/select-group";
import { getDefaultEstimatedTimeOfUse, getDefaultGender, getDefaultTeam } from "../../util";

// structure dài hạn cấp mới
export const longTermNewSecurityControlCardStructure: IInputArrayDataStructureItem[] = [
  {
    name: "unit",
    label: "Đơn vị",
    isVisibleOnList: true,
  },
  {
    name: "name",
    label: "Họ và tên",
    isVisibleOnList: true,
  },
  {
    name: "sex",
    label: "Giới tính",
    isVisibleOnList: true,
  },
  {
    name: "personalId",
    label: "CMND/CCCD/Hộ chiếu",
    isVisibleOnList: true,
  },
  {
    name: "regency",
    label: "Chức vụ",
    isVisibleOnList: true,
  },
  // {
  //   name: "KSANCardNumberIssued",
  //   label: "Số thẻ KSAN đã cấp(nếu có)",
  //   isVisibleOnList: true,
  // },
  {
    name: "grantTerm",
    label: "Thời hạn cấp",
    isVisibleOnList: true,
  },
  {
    name: "grantedArea",
    label: "Khu vực được cấp",
    isVisibleOnList: true,
  },
  // {
  //   name: "photocopyOfIDCard",
  //   label: "Giấy CMND photo công chứng (6 tháng)",
  //   isVisibleOnList: true,
  // },
  {
    name: "cardPhoto",
    label: "Ảnh thẻ 4x6 phông trắng, nền trắng (6 tháng)",
    isVisibleOnList: true,
  },
  {
    name: "photocopyOfCriminalRecord",
    label: "Bản photo lý lịch tư pháp (6 tháng)",
    isVisibleOnList: true,
  },
  {
    name: "personalStatement",
    label: "Bản khai cá nhân",
    isVisibleOnList: true,
  },
  {
    name: "photocopyOfLaborContract",
    label: "Bản photo hợp đồng lao động",
    isVisibleOnList: true,
  },
  {
    name: "expiredDate",
    label: "Ngày đến hạn",
    isVisibleOnList: true,
  },
  {
    name: "otherPhoto",
    label: "Hình ảnh khác",
    isVisibleOnList: true,
  },
  {
    name: "note",
    label: "Ghi chú",
    isVisibleOnList: true,
  },
];
// structure dài hạn gia hạn
export const longTermExtendSecurityControlCardStructure: IInputArrayDataStructureItem[] = [
  {
    name: "unit",
    label: "Đơn vị",
    isVisibleOnList: true,
  },
  {
    name: "name",
    label: "Họ và tên",
    isVisibleOnList: true,
  },
  {
    name: "sex",
    label: "Giới tính",
    isVisibleOnList: true,
  },
  {
    name: "personalId",
    label: "CMND/CCCD/Hộ chiếu",
    isVisibleOnList: true,
  },
  {
    name: "regency",
    label: "Chức vụ",
    isVisibleOnList: true,
  },
  {
    name: "KSANCardNumberIssued",
    label: "Số thẻ KSAN đã cấp",
    isVisibleOnList: true,
  },
  {
    name: "grantTerm",
    label: "Thời hạn cấp",
    isVisibleOnList: true,
  },
  {
    name: "grantedArea",
    label: "Khu vực được cấp",
    isVisibleOnList: true,
  },
  // {
  //   name: "photocopyOfIDCard",
  //   label: "Giấy CMND photo công chứng (6 tháng)",
  //   isVisibleOnList: true,
  // },
  {
    name: "cardPhoto",
    label: "Ảnh thẻ 4x6 phông trắng, nền trắng (2 năm)",
    isVisibleOnList: true,
  },
  {
    name: "photocopyOfCriminalRecord",
    label: "Bản photo lý lịch tư pháp",
    isVisibleOnList: true,
  },
  {
    name: "personalStatement",
    label: "Bản khai cá nhân",
    isVisibleOnList: true,
  },
  {
    name: "photocopyOfLaborContract",
    label: "Bản photo hợp đồng lao động",
    isVisibleOnList: true,
  },
  {
    name: "photoOldKSAN",
    label: "Bản photo ảnh thẻ KSAN cũ",
    isVisibleOnList: true,
  },
  {
    name: "expiredDate",
    label: "Ngày đến hạn",
    isVisibleOnList: true,
  },
  {
    name: "otherPhoto",
    label: "Hình ảnh khác",
    isVisibleOnList: true,
  },
  {
    name: "note",
    label: "Ghi chú",
    isVisibleOnList: true,
  },
];
// structure dài hạn cấp lại
export const longTermRenewSecurityControlCardStructure: IInputArrayDataStructureItem[] = [
  {
    name: "unit",
    label: "Đội/Tổ",
    isVisibleOnList: true,
  },
  {
    name: "name",
    label: "Họ và tên",
    isVisibleOnList: true,
  },
  {
    name: "sex",
    label: "Giới tính",
    isVisibleOnList: true,
  },
  {
    name: "personalId",
    label: "CMND/CCCD/Hộ chiếu",
    isVisibleOnList: true,
  },
  {
    name: "regency",
    label: "Chức vụ",
    isVisibleOnList: true,
  },
  {
    name: "KSANCardNumberIssued",
    label: "Số thẻ KSAN đã cấp",
    isVisibleOnList: true,
  },
  {
    name: "grantTerm",
    label: "Thời hạn cấp",
    isVisibleOnList: true,
  },
  {
    name: "grantedArea",
    label: "Khu vực được cấp",
    isVisibleOnList: true,
  },
  // {
  //   name: "photocopyOfIDCard",
  //   label: "Giấy CMND photo công chứng (6 tháng)",
  //   isVisibleOnList: true,
  // },
  {
    name: "cardPhoto",
    label: "Ảnh thẻ 4x6 phông trắng, nền trắng",
    isVisibleOnList: true,
  },
  {
    name: "photocopyOfCriminalRecord",
    label: "Bản photo lý lịch tư pháp",
    isVisibleOnList: true,
  },
  {
    name: "personalStatement",
    label: "Bản khai cá nhân",
    isVisibleOnList: true,
  },
  {
    name: "photocopyOfLaborContract",
    label: "Bản photo hợp đồng lao động",
    isVisibleOnList: true,
  },
  {
    name: "photoOldKSAN",
    label: "Bản photo thẻ kiểm soát an ninh cũ",
    isVisibleOnList: true,
  },
  {
    name: "ExcuseLose",
    label: "Đơn cớ mất",
    isVisibleOnList: true,
  },
  {
    name: "expiredDate",
    label: "Ngày đến hạn",
    isVisibleOnList: true,
  },
  {
    name: "otherPhoto",
    label: "Hình ảnh khác",
    isVisibleOnList: true,
  },
  {
    name: "note",
    label: "Ghi chú",
    isVisibleOnList: true,
  },
];
// form dài hạn cấp mới
export const LongTermNewSecurityControlCardContentForm: FC<IInputArrayFormProps> = (props: any) => {
  const { childFormData } = props;
  const today = new Date();
  const [estimatedTimeOfUse, setEstimatedTimeOfUse] = useState(getDefaultEstimatedTimeOfUse(childFormData?.grantTerm));
  const [expiredDate, setExpiredDate] = useState(
    childFormData?.expiredDate ? new Date(convertToDate(childFormData?.expiredDate)) : null,
  );
  const [selectedTeam, setSelectedTeam] = useState(
    getDefaultTeam(childFormData?.unit, props.teamList.length > 0 ? props.teamList[0] : null, props.teamList),
  );
  const genderSelect = [
    { label: "Nam", value: "male" },
    { label: "Nữ", value: "female" },
  ];
  const [gender, setGender] = useState(getDefaultGender(childFormData?.sex, genderSelect[0].value, genderSelect));
  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item: any) => {
      return {
        ...item,
        defaultValue: ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      values.grantTerm = estimatedTimeOfUse
        ? getDDMMYYYFormat(estimatedTimeOfUse[0]) + "-" + getDDMMYYYFormat(estimatedTimeOfUse[1])
        : values.grantTerm;
      values.expiredDate = expiredDate ? getDDMMYYYFormat(expiredDate) : null;
      values.unit = selectedTeam ? selectedTeam.value : values.unit;
      values.sex = gender && gender === "male" ? "Nam" : "Nữ";
      // values.otherPhoto = values.otherPhoto.length > 0 && JSON.stringify(values.otherPhoto);
      if (
        !values.name ||
        !values.sex ||
        !values.personalId ||
        !values.regency ||
        !values.unit ||
        // !values.KSANCardNumberIssued ||
        !values.grantTerm ||
        !values.grantedArea
        // !values.photocopyOfIDCard ||
        // !values.cardPhoto ||
        // !values.photocopyOfCriminalRecord ||
        // !values.personalStatement ||
        // !values.photocopyOfLaborContract
      ) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      } else {
        values.expiredDate = !expiredDate ? null : getDDMMYYYFormat(getDay(expiredDate));
        props.onSubmit(values);
      }
    },
  });

  const onTeamChange = (selectedOptions: any) => {
    setSelectedTeam(selectedOptions ? selectedOptions : null);
  };

  const onGenderChange = (selectedOptions: any) => {
    setGender(selectedOptions);
  };

  const onExpiredDateChange = (date: any) => {
    const newDate = new Date(date);
    setExpiredDate(newDate);
  };

  return (
    <div className="Form__add-new py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc phải nhập{" "}
      </h6>

      <InputWraper
        inputProps={getInputProps("unit")}
        renderInput={(s) => (
          <InputSelect
            {...s}
            options={props.teamList.map((o: any) => ({
              id: o.id,
              label: o.value,
              value: o.value,
            }))}
            value={selectedTeam?.value}
            onChange={onTeamChange}
            placeholder="* Chọn đội/tổ"
          />
        )}
        isRequired
      />

      <InputWraper inputProps={getInputProps("name")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper
        inputProps={getInputProps("sex")}
        renderInput={(s) => (
          <InputSelectTag {...s} options={genderSelect} value={gender} onChange={onGenderChange} gender={gender} />
        )}
        isRequired
      />

      <InputWraper inputProps={getInputProps("personalId")} renderInput={(s) => <InputNumber {...s} />} isRequired />

      <InputWraper inputProps={getInputProps("regency")} renderInput={(s) => <InputText {...s} />} isRequired />

      {/* <InputWraper
        inputProps={getInputProps("KSANCardNumberIssued")}
        renderInput={(s) => <InputText {...s} />}
      /> */}

      <InputWraper
        inputProps={getInputProps("grantTerm")}
        renderInput={(s) => (
          <InputDateRangePicker {...s} value={estimatedTimeOfUse} onChange={setEstimatedTimeOfUse} minDate={today} />
        )}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("grantedArea")}
        renderInput={(s) => <InputGroupSelect {...s} />}
        isRequired
      />

      {/* <InputWraper
        inputProps={getInputProps("photocopyOfIDCard")}
        renderInput={(s) => <UploadFile {...s} />}
        isRequired
      /> */}

      <InputWraper
        inputProps={getInputProps("cardPhoto")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("photocopyOfCriminalRecord")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("personalStatement")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("photocopyOfLaborContract")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("expiredDate")}
        renderInput={(s) => <InputDateTime {...s} value={expiredDate ?? null} onChange={onExpiredDateChange} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("otherPhoto")}
        renderInput={(s) => <UploadFile {...s} multiple={true} placeholder="Chọn 1 hoặc nhiều ảnh" />}
        // isRequired
      />
      <InputWraper inputProps={getInputProps("note")} renderInput={(s) => <InputText {...s} />} />

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};
// form dài hạn gia hạn
export const LongTermExtendSecurityControlCardContentForm: FC<IInputArrayFormProps> = (props: any) => {
  const { childFormData } = props;
  const today = new Date();
  const [expiredDate, setExpiredDate] = useState(
    childFormData?.expiredDate ? new Date(convertToDate(childFormData?.expiredDate)) : null,
  );
  const [estimatedTimeOfUse, setEstimatedTimeOfUse] = useState(getDefaultEstimatedTimeOfUse(childFormData?.grantTerm));
  const genderSelect = [
    { label: "Nam", value: "male" },
    { label: "Nữ", value: "female" },
  ];
  const [gender, setGender] = useState(getDefaultGender(childFormData?.sex, genderSelect[0].value, genderSelect));
  const [selectedTeam, setSelectedTeam] = useState(
    getDefaultTeam(childFormData?.unit, props.teamList.length > 0 ? props.teamList[0] : null, props.teamList),
  );

  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item: any) => {
      return {
        ...item,
        defaultValue: ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      values.grantTerm = estimatedTimeOfUse
        ? getDDMMYYYFormat(estimatedTimeOfUse[0]) + "-" + getDDMMYYYFormat(estimatedTimeOfUse[1])
        : values.grantTerm;
      values.unit = selectedTeam ? selectedTeam.value : values.unit;
      values.sex = gender && gender === "male" ? "Nam" : "Nữ";

      // values.otherPhoto = values.otherPhoto.length > 0 && JSON.stringify(values.otherPhoto);
      // values.grantedArea = values.grantedArea.length > 0 && JSON.stringify(values.grantedArea);
      if (
        !values.name ||
        !values.sex ||
        !values.personalId ||
        !values.regency ||
        !values.unit ||
        !values.KSANCardNumberIssued ||
        !values.grantTerm ||
        !values.grantedArea
        // !values.cardPhoto ||
        // !values.photocopyOfCriminalRecord ||
        // !values.personalStatement ||
        // !values.photocopyOfLaborContract
        // !values.photoOldKSAN
      ) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      } else {
        values.expiredDate = !expiredDate ? null : getDDMMYYYFormat(getDay(expiredDate));
        props.onSubmit(values);
      }
    },
  });

  const onTeamChange = (selectedOptions: any) => {
    setSelectedTeam(selectedOptions ? selectedOptions : null);
  };

  const onGenderChange = (selectedOptions: any) => {
    setGender(selectedOptions);
  };

  const onExpiredDateChange = (date: any) => {
    const newDate = new Date(date);
    setExpiredDate(newDate);
  };

  return (
    <div className="Form__add-new py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc phải nhập{" "}
      </h6>

      <InputWraper
        inputProps={getInputProps("unit")}
        renderInput={(s) => (
          <InputSelect
            {...s}
            options={props.teamList.map((o: any) => ({
              id: o.id,
              label: o.value,
              value: o.value,
            }))}
            value={selectedTeam?.value}
            onChange={onTeamChange}
            placeholder="* Chọn đội/tổ"
          />
        )}
        isRequired
      />

      <InputWraper inputProps={getInputProps("name")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper
        inputProps={getInputProps("sex")}
        renderInput={(s) => (
          <InputSelectTag {...s} options={genderSelect} value={gender} onChange={onGenderChange} gender={gender} />
        )}
        isRequired
      />

      <InputWraper inputProps={getInputProps("personalId")} renderInput={(s) => <InputNumber {...s} />} isRequired />

      <InputWraper inputProps={getInputProps("regency")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper
        inputProps={getInputProps("KSANCardNumberIssued")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("grantTerm")}
        renderInput={(s) => (
          <InputDateRangePicker {...s} value={estimatedTimeOfUse} onChange={setEstimatedTimeOfUse} minDate={today} />
        )}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("grantedArea")}
        renderInput={(s) => <InputGroupSelect {...s} />}
        isRequired
      />

      {/* <InputWraper
        inputProps={getInputProps("photocopyOfIDCard")}
        renderInput={(s) => <UploadFile {...s} />}
        isRequired
      /> */}

      <InputWraper
        inputProps={getInputProps("cardPhoto")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("photocopyOfCriminalRecord")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("personalStatement")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("photocopyOfLaborContract")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("photoOldKSAN")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("expiredDate")}
        renderInput={(s) => <InputDateTime {...s} value={expiredDate ?? null} onChange={onExpiredDateChange} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("otherPhoto")}
        renderInput={(s) => <UploadFile {...s} multiple={true} placeholder="Chọn 1 hoặc nhiều ảnh" />}
        // isRequired
      />

      <InputWraper inputProps={getInputProps("note")} renderInput={(s) => <InputText {...s} />} />

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};
// form dài hạn cấp lại
export const LongTermRenewSecurityControlCardContentForm: FC<IInputArrayFormProps> = (props: any) => {
  const { childFormData } = props;
  const today = new Date();
  const [expiredDate, setExpiredDate] = useState(
    childFormData?.expiredDate ? new Date(convertToDate(childFormData?.expiredDate)) : null,
  );
  const [estimatedTimeOfUse, setEstimatedTimeOfUse] = useState(getDefaultEstimatedTimeOfUse(childFormData?.grantTerm));
  const [selectedTeam, setSelectedTeam] = useState(
    getDefaultTeam(childFormData?.unit, props.teamList.length > 0 ? props.teamList[0] : null, props.teamList),
  );
  const genderSelect = [
    { label: "Nam", value: "male" },
    { label: "Nữ", value: "female" },
  ];
  const [gender, setGender] = useState(getDefaultGender(childFormData?.sex, genderSelect[0].value, genderSelect));
  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item: any) => {
      return {
        ...item,
        defaultValue: ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      values.grantTerm = estimatedTimeOfUse
        ? getDDMMYYYFormat(estimatedTimeOfUse[0]) + "-" + getDDMMYYYFormat(estimatedTimeOfUse[1])
        : values.grantTerm;
      values.unit = selectedTeam ? selectedTeam.value : values.unit;
      values.sex = gender && gender === "male" ? "Nam" : "Nữ";
      values.ExcuseLose = values.ExcuseLose.length > 0 && JSON.stringify(values.ExcuseLose);
      // values.otherPhoto = values.otherPhoto.length > 0 && JSON.stringify(values.otherPhoto);
      // values.grantedArea = values.grantedArea.length > 0 && JSON.stringify(values.grantedArea);
      if (
        !values.name ||
        !values.sex ||
        !values.personalId ||
        !values.regency ||
        !values.unit ||
        !values.KSANCardNumberIssued ||
        !values.grantTerm ||
        !values.grantedArea ||
        // !values.cardPhoto ||
        // !values.photocopyOfCriminalRecord ||
        // !values.personalStatement ||
        // !values.photocopyOfLaborContract ||
        // !values.photoOldKSAN ||
        !values.ExcuseLose
      ) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      } else {
        values.expiredDate = !expiredDate ? null : getDDMMYYYFormat(getDay(expiredDate));
        props.onSubmit(values);
      }
    },
  });

  const onTeamChange = (selectedOptions: any) => {
    setSelectedTeam(selectedOptions ? selectedOptions : null);
  };

  const onGenderChange = (selectedOptions: any) => {
    setGender(selectedOptions);
  };

  const onExpiredDateChange = (date: any) => {
    const newDate = new Date(date);
    setExpiredDate(newDate);
  };

  return (
    <div className="Form__add-new py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc phải nhập{" "}
      </h6>

      <InputWraper
        inputProps={getInputProps("unit")}
        renderInput={(s) => (
          <InputSelect
            {...s}
            options={props.teamList.map((o: any) => ({
              id: o.id,
              label: o.value,
              value: o.value,
            }))}
            value={selectedTeam?.value}
            onChange={onTeamChange}
            placeholder="* Chọn đội/tổ"
          />
        )}
        isRequired
      />

      <InputWraper inputProps={getInputProps("name")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper
        inputProps={getInputProps("sex")}
        renderInput={(s) => (
          <InputSelectTag {...s} options={genderSelect} value={gender} onChange={onGenderChange} gender={gender} />
        )}
        isRequired
      />

      <InputWraper inputProps={getInputProps("personalId")} renderInput={(s) => <InputNumber {...s} />} isRequired />

      <InputWraper inputProps={getInputProps("regency")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper
        inputProps={getInputProps("KSANCardNumberIssued")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("grantTerm")}
        renderInput={(s) => (
          <InputDateRangePicker {...s} value={estimatedTimeOfUse} onChange={setEstimatedTimeOfUse} minDate={today} />
        )}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("grantedArea")}
        renderInput={(s) => <InputGroupSelect {...s} />}
        isRequired
      />

      {/* <InputWraper
        inputProps={getInputProps("photocopyOfIDCard")}
        renderInput={(s) => <UploadFile {...s} />}
        isRequired
      /> */}

      <InputWraper
        inputProps={getInputProps("cardPhoto")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("photocopyOfCriminalRecord")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("personalStatement")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("photocopyOfLaborContract")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("photoOldKSAN")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper inputProps={getInputProps("ExcuseLose")} renderInput={(s) => <Upload {...s} />} isRequired />
      <InputWraper
        inputProps={getInputProps("expiredDate")}
        renderInput={(s) => <InputDateTime {...s} value={expiredDate ?? null} onChange={onExpiredDateChange} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("otherPhoto")}
        renderInput={(s) => <UploadFile {...s} multiple={true} placeholder="Chọn 1 hoặc nhiều ảnh" />}
        // isRequired
      />
      <InputWraper inputProps={getInputProps("note")} renderInput={(s) => <InputText {...s} />} />

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};
